<template>
  <div class="diseaseCode">
    <div class="warpper">
      <div class="top" v-if="!edit">
        <div class="btn">
          <el-button type="primary" @click="allList()">全部</el-button>
        </div>
        <!--<div class="_op">
          <el-select v-model="type" placeholder="疾病类别" style="width: 130px">
            <el-option
              v-for="(item, index) in types"
              :key="index"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>-->
        <div class="keyword">
          <el-input v-model="keyword" placeholder="请输入搜索内容" @keyup.enter.native="search()"></el-input>
        </div>
        <div class="btn">
          <el-button type="primary" @click="search()">搜索</el-button>
        </div>
      </div>
      <div class="top" v-else>药品编辑</div>
      <div class="content" v-if="durgList.length > 0">
        <div class="left" v-if="!edit">
          <div class="drug-item" v-for="(item, index) in durgList" :key="index">
            <div class="_item-title">
              <el-radio v-model="durgItem" :label="index" @change="durgChange">{{ item.title }}</el-radio>
              <span class="code-type" v-if="item.type && item.type">{{ item.type }} （{{ item.code }}）</span>
              <span class="code-type" v-if="item.departmentName">{{
                item.departmentName
              }}</span>
            </div>
          </div>
          <div class="left_foo">
            <el-pagination small @current-change="currentPageChange" :page-size="page.pageSize"
              :current-page="page.pageNo" :total="page.total" layout="total, prev, pager, next"></el-pagination>
          </div>
        </div>
      </div>
      <div class="emptyDataCenter" v-else>
        <emptyData></emptyData>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
/**
 * @name 药品筛选弹窗
 * @desc 数据列表
 */
import util from "@/utils";
// import { disease_code } from "@/api";
import { getDisease } from "@/api/doctor";
import emptyData from "@/components/common/emptyData";
import { Dialog } from "element-ui";
export default {
  components: {
    emptyData,
  },
  props: {
    drugs: Array,
    // departmentId: String,
  },
  data() {
    return {
      keyword: "",
      types: [
        { title: "ICD-10", id: "ICD-10" },
        { title: "GB-95", id: "GB-95" },
      ],
      type: "",
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      durgList: [],
      caseForm: {
        drugs_id: "",
        drugNum: "",
        dosage: "",
        unit: "",
        frequency: "",
        from: "",
        time: "",
        remark: "",
      },
      durgItem: "",
      curCase: "",
      edit: false,
      rightShow: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * 全部
     */
    allList() {
      this.type = "";
      this.keyword = "";
      this.page.pageNo = 1;
      this.rightShow = false;
      this.init();
    },
    search() {
      this.page.pageNo = 1;
      this.rightShow = false;
      this.init();
    },

    async init() {
      const params = {
        diseaseName: this.keyword,
        currentPage: this.page.pageNo,
        pageSize: this.page.pageSize,
      };
      const res = await getDisease(params);
      if (res.code == 1) {
        this.durgList = res.data.dataList;
        this.durgItem = "";
        this.page.pageNo = Number(res.data.currentPage);
        this.page.total = Number(res.data.totalCount);
      }
    },
    //初始化数据项
    // async init() {
    //   try {
    //     let params = {
    //       title:this.keyword,
    //       type: this.type,
    //       // departmentId: this.departmentId,
    //       pageNo: this.page.pageNo,
    //       pageSize: this.page.pageSize,
    //     };
    //     let res = await disease_code(params);
    //     if (res.success) {
    //       this.durgList = res.result.records;
    //       this.durgItem = "";
    //       this.page.pageNo = res.result.current;
    //       this.page.total = res.result.total;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    //分页
    currentPageChange(e) {
      this.page.pageNo = e;
      this.rest();
      this.init();
    },
    //选择事件
    durgChange(e) {
      this.rightShow = true;
      this.curCase = this.durgList[e];
      console.log("this.curCase", this.curCase);
      if (this.curCase.isHighRisk) {
        this.$confirm("高危诊断限制不能开具高危诊断结果", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
        return
      }
      this.$emit("on_disease_code", this.curCase, false);
    },
    rest() {
      this.edit = false;
      this.rightShow = false;
      this.curCase = "";
      this.durgItem = "";
    },
  },
};
</script>

<style lang="scss" type="text/css">
.diseaseCode {
  .warpper {
    min-height: 570px;

    .top {
      display: flex;
      width: 75%;
      color: #999999;

      ._op {
        flex: 0 0 20%;
        display: flex;
        align-items: center;
      }

      .keyword {
        flex: 1;
        display: flex;
        align-items: center;
        margin-left: 5px;
      }
    }

    .content {
      display: flex;
      margin: 20px 0 0 0;

      .left {
        flex: 1;
        border: none;
        margin-right: 5px;

        .drug-item {
          background: #fafafa;
          margin: 10px 20px 0 0;

          ._item-title {
            display: flex;
            align-items: center;
            padding: 10px 20px;
          }
        }

        .left_foo {
          margin-top: 15px;
          text-align: center;
          font-size: 22px;
          // i:nth-child(1) {
          //   margin-right: 20px;
          // }
        }
      }

      .right {
        flex: 0 0 50%;

        .foo {
          display: flex;
        }
      }
    }

    .emptyDataCenter {
      min-height: 500px;
      margin: 0 auto;
      align-items: center;
    }
  }

  .code-type {
    position: absolute;
    right: 70px;
  }
}
</style>
